export default __webpack_public_path__ + "static/media/4.7cde46e1.png";